import React from 'react';
import Modal from '../shared/Modal';
import { formatDateTime, formatDate } from '../../utils/dates';

function PersonDetail({ person, onClose }) {
  if (!person) return null;
  const initial = person.person_name[0].toUpperCase();
  const allMentions = Array.isArray(person.mentions) ? person.mentions : [];
  const firstDate = allMentions.length > 0
    ? allMentions[allMentions.length - 1]?.created_at
    : null;

  return (
    <Modal isOpen={!!person} onClose={onClose} title={person.person_name} size="md">
      <div className="person-detail">
        <div className="person-detail__header">
          <div className="person-avatar person-avatar--lg">{initial}</div>
          <div>
            <div className="person-detail__roles">
              {(person.roles || []).filter(Boolean).join(' · ')}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
              {person.mention_count} menciones
              {firstDate && ` — primera vez: ${formatDate(firstDate)}`}
            </div>
          </div>
        </div>

        <h4 style={{ marginTop: 20, marginBottom: 12, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-muted)' }}>
          Historial de apariciones
        </h4>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {allMentions.map((m, i) => (
            <div key={m.id || i} style={{ borderLeft: '2px solid var(--border)', paddingLeft: 12 }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                  {formatDateTime(m.created_at)}
                </span>
              </div>
              {m.context && (
                <div style={{ fontSize: 13, color: 'var(--text)' }}>{m.context}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default PersonDetail;
